import { useAuthContext } from 'state/auth';
import { useOrderContext } from 'state/order';
import { isKiosk } from 'utils/environment';
import { isCatering } from 'utils/service-mode';

export const useRecentItemsAvailable = () => {
  const { user } = useAuthContext();
  const hasUniquePurchasedItems = !!user?.uniquePurchasedItems?.length;
  const { serviceMode } = useOrderContext();
  const isCateringServiceMode = isCatering(serviceMode);
  return !isKiosk && !isCateringServiceMode && hasUniquePurchasedItems;
};
